
import { Component, Vue } from 'vue-property-decorator';
import { BModal } from 'bootstrap-vue';
import UpdatesListing from './UpdatesListing.vue';
import { makeFormModel } from 'ah-common-lib/src/form/helpers';
import { selectField } from 'ah-common-lib/src/form/models';
import { UpdateTypeDescriptions } from 'ah-api-gateways';

@Component({
  components: {
    UpdatesListing,
  },
})
export default class UpdatesModal extends Vue {
  $refs!: {
    modal: BModal;
  };

  private updatesTypeForm = makeFormModel({
    name: 'updatesTypeFm',
    fieldType: 'form',
    fields: [
      selectField(
        'updatesType',
        '',
        [
          {
            value: null,
            label: 'All update types',
          },
          ...Object.keys(UpdateTypeDescriptions).map((key) => ({
            value: key,
            label: (UpdateTypeDescriptions as any)[key],
          })),
        ],
        {
          required: false,
          defaultValue: null,
        }
      ),
    ],
  });

  show() {
    this.$refs.modal.show();
  }
}
